export default "__VITE_ASSET__BUUXB8kP__"